import type { AttachmentItem } from '@/types/models'

export const removeAttachmentItems = (
  state: AttachmentItem[],
  items: AttachmentItem[]
): AttachmentItem[] => {
  const idsToRemoveSet = new Set(items.map((item) => item.id))

  return state.filter((item) => !idsToRemoveSet.has(item.id))
}
